import {
  ForceLocked,
  Heading,
  ForcedWarning,
  Arrow,
  theme,
  Refresh,
  ForcedSuccess,
  ForceUnlocked,
} from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { getSSOManageAccountLink } from 'utils'
import { useEffect, useState } from 'react'
import { getJSON } from 'common/services/api'

export const ForceMFAScreen = () => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  const [isLoading, setIsLoading] = useState(false)

  const [locked, isLocked] = useState(true)

  const checkMFAsetup = async (onFinish?: () => void) => {
    try {
      const payload = await getJSON({ url: '/private-ping' })

      if (!payload.code) {
        isLocked(false)
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}

    onFinish?.()
  }

  useEffect(() => {
    const interval = setInterval(() => {
      checkMFAsetup()
    }, 60000)

    if (!locked) {
      clearInterval(interval)
    }

    return () => clearInterval(interval)
  }, [locked])

  const handleRefresh = () => {
    setIsLoading(true)
    checkMFAsetup(() => setIsLoading(false))
  }

  return (
    <Wrapper>
      <TopWrapper>
        {locked ? <ForcedWarning /> : <ForcedSuccess />}
        <StyledHeading level={2}>
          {t(generalConstants[locked ? 'MFA_LOCKED' : 'MFA_COMPLETE'])}
        </StyledHeading>
      </TopWrapper>
      {locked ? <ForceLocked /> : <ForceUnlocked />}
      <StyledHeading level={2}>
        {t(generalConstants[locked ? 'MFA_ENSURE' : 'MFA_SECURED'])}
      </StyledHeading>
      <StyledText level={1}>
        {t(generalConstants[locked ? 'MFA_ENSURE_CLICK' : 'MFA_SECURED_CLICK'])}
      </StyledText>
      <BottomWrapper>
        {locked && (
          <Button
            variant="default"
            onClick={handleRefresh}
            isLoading={isLoading}
          >
            {t(generalConstants.REFRESH)}
            <Refresh />
          </Button>
        )}
        {locked && (
          <StyledMainButton
            variant="primary"
            onClick={() => window.open(getSSOManageAccountLink(), '_blank')}
          >
            {t(generalConstants.SET_UP_NOW)}
            <Arrow
              direction="right"
              size={20}
              color={theme.color.neutral.color11}
            />
          </StyledMainButton>
        )}
        {!locked && (
          <StyledMainButton
            variant="primary"
            onClick={() => window.location.replace('/')}
          >
            {t(generalConstants.MFA_LOGIN)}
          </StyledMainButton>
        )}
      </BottomWrapper>
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const BottomWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin: 20px;
  margin-top: auto;
  margin-bottom: 0px;
  padding: 18px;
  border-top: 1px solid;
  width: 100%;
  border-color: ${(props) => props.theme.color.neutral.color8};
  margin-right: 20px;
  margin-left: 20px;
`

export const TopWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 20px;
  margin-top: 0;
  margin-bottom: auto;
  padding: 18px;
  border-bottom: 1px solid;
  width: 100%;
  border-color: ${(props) => props.theme.color.neutral.color8};
  margin-right: 20px;
  margin-left: 20px;
`

const StyledHeading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color4};
  text-align: center;
  margin: 10px;
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    max-width: unset;
  }
`

const StyledText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
  text-align: center;
`

const StyledMainButton = styled(Button)`
  margin-left: 10px;
`
